module.exports = __webpack_public_path__ + "static/media/incorrect1.28ba5b87.mp3";